define("@ember/routing/history-location", ["exports", "@ember/-internals/routing"], function (_exports, _routing) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "default", {
    enumerable: true,
    get: function () {
      return _routing.HistoryLocation;
    }
  });
});